module.exports = __webpack_public_path__ + "static/img/jascap_logo.105bfc00.jpg";